import { FC } from "react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/_atoms/button";

import { startFederatedLogin } from "../services/auth.service";

interface FederatedContinueButtonProps {
  startUrl: string;
}

export const FederatedContinueButton: FC<FederatedContinueButtonProps> = ({ startUrl }) => {
  const { t } = useTranslation("auth");

  return (
    <Button
      onClick={() => startFederatedLogin(startUrl)}
      variant="default"
      className="h-10 w-48 items-center justify-center text-sm"
    >
      {t("invite.workspace.federatedContinue")}
    </Button>
  );
};
